// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"108":"e65dd595b78195079cea","245":"0cc81defdb2f2b708e2d","452":"a4cf7a84f6f6f5a81b79","453":"fa1439d47ff76169b0b8"}[chunkId] + ".js";
};